<div>
  <form [formGroup]="secondFormGroup">
    <div class="right-side">
      <div class="select-profile-input">
        <mat-form-field appearance="outline"
                        class="pointer-cursor"
                        (click)="openList($event, triggerProfiles)">
          <mat-label>Perfil</mat-label>
          <input #triggerProfiles="matAutocompleteTrigger"
                 type="text"
                 [matAutocomplete]="autoProfiles"
                 matInput
                 formControlName="idsProfilesText"
                 readonly
                 class="pointer-cursor" />
          <mat-error *ngIf="secondFormGroup.get('idsProfiles')?.hasError('required')">Selecione um pefil</mat-error>
          <mat-autocomplete #autoProfiles="matAutocomplete">
            <mat-option [style.display]="'none'"></mat-option>
            <app-profile-simple-list [selectAllText]="profilesSelectAllText"
                                     [initialIdProfiles]="selectedIdsProfiles"
                                     (selectEvent)="handleProfileSelect($event)"
                                     [hidePhoto]="true"
                                     [excludeProfiles]="excludeProfiles"
                                     [hideButtons]="true">
            </app-profile-simple-list>
          </mat-autocomplete>

          <span matSuffix
                class="material-icons"
                *ngIf="!autoProfiles.isOpen && secondFormGroup.enabled">
            expand_more
          </span>

          <span matSuffix
                class="material-icons"
                *ngIf="autoProfiles.isOpen && secondFormGroup.enabled">
            expand_less
          </span>
        </mat-form-field>
      </div>

      <div class="year-classrooms">
        <div class="year"
             *ngIf="startTxtYear"
             [ngClass]="{'disabled': secondFormGroup.disabled}">
          <app-school-year-combo class="year"
                                 [txtYear]="startTxtYear"
                                 (yearSelected)="getYearSelected($event)">
          </app-school-year-combo>
        </div>

        <div class="classrooms">
          <mat-form-field appearance="outline"
                          class="pointer-cursor"
                          (click)="openList($event, triggerClassroom)">
            <mat-label>Turmas</mat-label>
            <input #triggerClassroom="matAutocompleteTrigger"
                   type="text"
                   matInput
                   formControlName="idsClassroomsText"
                   [matAutocomplete]="autoClassroom"
                   readonly
                   class="pointer-cursor" />
            <mat-autocomplete #autoClassroom="matAutocomplete">
              <mat-option [style.display]="'none'"></mat-option>
              <app-select-hierarquical-list *ngIf="segmentTreeData.length > 0"
                                            [treeData]="segmentTreeData"
                                            [initialSelection]="selectedIdsClassrooms"
                                            (selectEvent)="handleSelectClassroom($event)"
                                            [hideButtons]="true">
              </app-select-hierarquical-list>
            </mat-autocomplete>
            <mat-error *ngIf="secondFormGroup.get('idsClassrooms')?.hasError('required')">
              Selecione uma Turma
            </mat-error>

            <span matSuffix
                  class="material-icons"
                  *ngIf="!autoClassroom.isOpen  && secondFormGroup.enabled">
              expand_more
            </span>

            <span matSuffix
                  class="material-icons"
                  *ngIf="autoClassroom.isOpen  && secondFormGroup.enabled">
              expand_less
            </span>
          </mat-form-field>
        </div>
      </div>
    </div>
  </form>
</div>
